// removed by extract-text-webpack-plugin
module.exports = {"dotControls":"arrowStyles__dotControls__16md7","dotWrapper":"arrowStyles__dotWrapper__3Of_L","dot":"arrowStyles__dot__3EdFv","current":"arrowStyles__current__1a1Fl","buyer":"arrowStyles__buyer__1YKvO","trade":"arrowStyles__trade__1nWCr","dotCarouselWrapper":"arrowStyles__dotCarouselWrapper__62_SD","clear":"arrowStyles__clear__39TNC"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/global/components/carousel/views/arrowStyles.scss
// module id = 517
// module chunks = 5 7 8 9 10 11 13 23 25 29 57 58